// extracted by mini-css-extract-plugin
module.exports = {"smBreakpoint":"576px","mdBreakpoint":"768px","lgBreakpoint":"1024px","xlBreakpoint":"1366px"};